module.exports = __webpack_public_path__ + "static/img_1.da2410e9.jpg";